import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiCalendar, FiMenu, FiX, FiPhoneCall } from 'react-icons/fi';
import './PillNav.css';

const PillNav = ({ logo, logoAlt = 'Swarup Hospital Logo', items, activeHref }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    if (!isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  };

  const isRouterLink = (href) => href && !href.startsWith('#') && !href.startsWith('tel:') && !href.startsWith('mailto:');

  return (
    <div className={`nav-bar-container ${isScrolled ? 'is-scrolled' : ''}`}>
      <div className="nav-bar-inner">
        {/* Logo Section */}
        <Link className="nav-logo" to="/" aria-label="Home">
          <img src={logo} alt={logoAlt} className="logo-img-large" />
        </Link>

        {/* Desktop Menu */}
        <div className="desktop-menu-wrapper">
          <ul className="desktop-nav-list" role="menubar">
            {items.map((item, i) => {
              const isCta = item.href === '/appointments';
              return (
                <li key={item.href || `item-${i}`} role="none">
                  {isRouterLink(item.href) ? (
                    <Link
                      role="menuitem"
                      to={item.href}
                      className={`nav-link-item ${activeHref === item.href ? 'is-active' : ''} ${isCta ? 'nav-link-cta' : ''}`}
                    >
                      {isCta && <FiCalendar className="cta-calendar-icon" />}
                      <span>{item.label}</span>
                    </Link>
                  ) : (
                    <a
                      role="menuitem"
                      href={item.href}
                      className={`nav-link-item ${activeHref === item.href ? 'is-active' : ''} ${isCta ? 'nav-link-cta' : ''}`}
                    >
                      {isCta && <FiCalendar className="cta-calendar-icon" />}
                      <span>{item.label}</span>
                    </a>
                  )}
                </li>
              );
            })}
          </ul>
        </div>

        {/* Mobile Hamburger Toggle */}
        {!isMobileMenuOpen && (
          <button
            className="mobile-menu-hamburger"
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            <FiMenu size={26} />
          </button>
        )}
      </div>


      {/* Mobile Menu Popover */}
      {isMobileMenuOpen && (
        <>
          <div className="mobile-menu-backdrop" onClick={toggleMobileMenu} aria-hidden="true" />
          <div className="mobile-menu-overlay">
            <div className="mobile-drawer-header">
              <img src={logo} alt={logoAlt} className="logo-img-large-mobile" />
              <button className="mobile-drawer-close" onClick={toggleMobileMenu}>
                <FiX size={26} />
              </button>
            </div>
            <ul className="mobile-menu-list">
              {items.map((item, i) => (
                <li key={item.href || `mobile-item-${i}`}>
                  {isRouterLink(item.href) ? (
                    <Link
                      to={item.href}
                      className={`mobile-menu-link ${activeHref === item.href ? 'is-active' : ''} ${item.href === '/appointments' ? 'mobile-menu-cta' : ''}`}
                      onClick={() => {
                        setIsMobileMenuOpen(false);
                        document.body.style.overflow = 'unset';
                      }}
                    >
                      {item.href === '/appointments' && <FiCalendar style={{ marginRight: '8px' }} />}
                      {item.label}
                    </Link>
                  ) : (
                    <a
                      href={item.href}
                      className={`mobile-menu-link ${activeHref === item.href ? 'is-active' : ''} ${item.href === '/appointments' ? 'mobile-menu-cta' : ''}`}
                      onClick={() => {
                        setIsMobileMenuOpen(false);
                        document.body.style.overflow = 'unset';
                      }}
                    >
                      {item.href === '/appointments' && <FiCalendar style={{ marginRight: '8px' }} />}
                      {item.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
            <div className="mobile-drawer-footer">
              <p>Emergency Helpline</p>
              <a href="tel:108" className="mobile-drawer-phone">
                <FiPhoneCall /> 108 (24/7 Support)
              </a>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PillNav;
